export function visibleFocusHandler() {
    window.addEventListener("mousedown", handleMouseDownOnce);
}

function handleMouseDownOnce() {
    if (!document.documentElement.classList.contains("no-focus-outline")) {
        document.documentElement.classList.add("no-focus-outline");
    }

    window.removeEventListener("mousedown", handleMouseDownOnce);
    window.addEventListener("keydown", handleFirstTab);
}

function handleFirstTab(evt) {
    // If not Tab Key...
    if (evt.keyCode !== 9) {
        return;
    }

    if (document.documentElement.classList.contains("no-focus-outline")) {
        document.documentElement.classList.remove("no-focus-outline");
    }

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
}
